import PropTypes from 'prop-types';
import { Chip } from '@mui/material';

const styles = {
  chip: ({ palette }) => ({
    width: 65,
    backgroundColor: palette.colors.darkPale,
    fontSize: 16,
  }),
};

export const TableNumberValue = ({ value }) => {
  return <Chip sx={styles.chip} label={value} />;
};

TableNumberValue.propTypes = {
  value: PropTypes.number.isRequired,
};
